module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6109659703109e02be27d559070ca726.png";